import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import { ReactNode } from 'react';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';

interface VizTotalProps {
  value: string;
  caption?: string | null;
  isStacked?: boolean;
  children?: ReactNode;
}

const VizTotal = ({ value, caption, isStacked, children }: VizTotalProps) => {
  const { translate } = useTranslation();

  return (
    <Stack
      direction={isStacked ? 'column' : 'row'}
      sx={[{ minWidth: 0 }, !isStacked && { alignItems: 'baseline', gap: 1, flexWrap: 'wrap' }]}
    >
      <Typography variant="subtitle1" noWrap={isStacked}>
        {value}
      </Typography>
      <Typography variant="body2" color="text.tertiary">
        {caption ?? translate(LangEnum.GLOBAL_TOTAL)}
      </Typography>
      {children}
    </Stack>
  );
};

export default VizTotal;
